import { createRouter, createWebHistory } from 'vue-router'


const routes = [
  {
    path: '/solicitud-pasaporte',
    name: 'SolicitudPasaporte',
    component: () => import('@/views/SolicitudPasaporte.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import( '../views/Home/HomeViews.vue')
  },
  {
  path: '/politica-privacidad',
  name: 'PoliticaPrivacidad',
  component: () => import('@/views/PoliticaPrivacidad.vue')
},
{
  path: '/terminos-servicio',
  name: 'TerminosServicio',
  component: () => import('@/views/TerminosServicio.vue')
}
 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
      
    }
    if (to.hash) {
      return{
        el:to.hash,
        behavior:'smooth'
      }
      
      
    }
    return { top: 0 }
  }
})

export default router
